import classNames from "classnames";
import CardBody from "components/molecules/Card/CardBody";
import errorFallbackUI from "components/molecules/ErrorFallbackUI.tsx/ErrorFallbackUI";
import { ComponentErrorBoundary } from "components/molecules/ErrorStates";
import usePlansState from "recoilStore/Building/usePlansState";
import { CapitalSections, prepareCapitalData } from "./CapitalCard.helper";
import "./CapitalCard.scss";
import CapitalSummary from "./CapitalSummary/CapitalSummary";

function CapitalCard() {
    const { referencePlan, comparedPlan, comparedPlanName, referencePlanName, comparingToBaseline } = usePlansState();

    const { capexData, savingsData, cardHeaderData } = prepareCapitalData(
        referencePlan,
        comparedPlan,
        comparedPlanName,
        referencePlanName,
        comparingToBaseline
    );

    const { sections: capexSections } = capexData;
    const { sections: savingsSections } = savingsData;

    return (
        <div className={classNames("card", "capital-card-container")}>
            <div className={classNames("card")}>
                <CapitalSummary section={CapitalSections.CAPEX} cardHeaderData={cardHeaderData} />
                <ComponentErrorBoundary fallback={errorFallbackUI("cardBodyError")} originComponent="Card">
                    <CardBody sections={capexSections} multipleInvertedColors={true} />
                </ComponentErrorBoundary>
            </div>
            <div className={classNames("card")}>
                <CapitalSummary section={CapitalSections.SAVINGS} cardHeaderData={cardHeaderData} />
                <ComponentErrorBoundary fallback={errorFallbackUI("cardBodyError")} originComponent="Card">
                    <CardBody sections={savingsSections} multipleInvertedColors={true} />
                </ComponentErrorBoundary>
            </div>
        </div>
    );
}

export default CapitalCard;
